import { StructureLogsTable } from "components/Tables/StructureLogsTable/StructureLogsTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/structure/")({
    component: StructureLogsPage,
    staticData: {
        permissions: [PermissionEnum.StructureLogsView],
        showInSideMenu: false,
        label: "pages.log.structure.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.structure.title"),
        };
    },
});

function StructureLogsPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <StructureLogsTable />
        </TenantPage>
    );
}
